// Shared logout flag. The sign-out flow lives in useSignOutUser and is started from the main menu,
// which unmounts the moment auth state clears (it is gated on the user being logged in), so the
// "signing out" overlay has to be rendered from the always-mounted app root instead. This shared
// state bridges the two.
export const useSignOutState = () => useState<boolean>('signingOut', () => false);
